<template>
  <el-dialog
      id="createTestCollectionOrderDialog"
      :title="title"
      :visible="isShowCreateTestCollectionOrderDialog"
      width="600px"
      @open="handleDialogOpen"
      @close="handleDialogClose"
      :close-on-click-modal="false"
  >
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        v-show="submitted === false"
    >
      <el-form-item
          :label="$t('text.merchantUserId')"
          prop="merchantUserId"
      >
        <el-input
            v-model="form.merchantUserId"
            auto-complete="off"
            :placeholder="$t('message.inputMerchantUserId')"
        />
      </el-form-item>
      <el-form-item
          :label="$t('text.orderAmountCent')"
          prop="amount"
      >
        <el-input
            v-model="form.amount"
            auto-complete="off"
            :placeholder="$t('message.inputOrderAmountCent')"
        />
      </el-form-item>
      <el-form-item
          :label="$t('text.customerName')"
          prop="customerName"
      >
        <el-input
            v-model="form.customerName"
            auto-complete="off"
            :placeholder="$t('message.inputCustomerName')"
        />
      </el-form-item>
      <el-form-item
          :label="$t('text.customerCert')"
          prop="customerCert"
      >
        <el-input
            v-model="form.customerCert"
            auto-complete="off"
            :placeholder="$t('message.inputCustomerCert')"
        />
      </el-form-item>
      <el-form-item
          :label="$t('text.customerEmail')"
          prop="customerEmail"
      >
        <el-input
            v-model="form.customerEmail"
            auto-complete="off"
            :placeholder="$t('message.inputCustomerEmail')"
        />
      </el-form-item>
      <el-form-item
          :label="$t('text.customerPhone')"
          prop="customerPhone"
      >
        <el-input
            v-model="form.customerPhone"
            auto-complete="off"
            :placeholder="$t('message.inputCustomerPhone')"
        />
      </el-form-item>
      <el-form-item
          :label="$t('text.defaultChannelName')"
          prop="defaultChannelName"
      >
        <el-select
            v-model="form.defaultChannelName"
            filterable
            :placeholder="$t('message.selectDefaultChannelName')"
        >
          <el-option
              v-for="item in defaultChannelNameOptions"
              :key="item"
              :label="item"
              :value="item"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <el-row
        v-show="submitted"
    >
      <el-col
          :span="20"
          v-if="result.success"
      >
        <el-input
            :readonly="true"
            :value="result.link"
        />
      </el-col>
      <el-col
          :span="4"
          style="text-align: center"
          v-if="result.success"
      >
        <el-button
            @click="handleCopyClick"
        >
          {{ $t('text.copy') }}
        </el-button>
      </el-col>
      <el-col
          :span="24"
          v-if="result.success === false"
      >
        {{ result.message }}
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancelClick" v-if="submitted === false">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirmClick" v-if="submitted === false">{{
          $t('text.confirm')
        }}
      </el-button>
      <el-button type="primary" @click="handleCloseClick" v-if="submitted">{{ $t('text.close') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShowCreateTestCollectionOrderDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        merchantUserId: "testuser001",
        amount: "10000",
        customerName: "Irak Shang",
        customerCert: "1730155170675",
        customerEmail: "erichsiungz@gmail.com",
        customerPhone: (this.$store.state.isPK) ? "3115118268" : "1115118268",
        defaultChannelName: (this.$store.state.isPK) ? "jazzcash" : "bKash"
      },
      rules: {
        merchantUserId: [
          {required: true, message: this.$t('message.inputMerchantUserId')},
        ],
        amount: [
          {required: true, message: this.$t('message.inputAmountCent')},
        ],
        customerName: [
          {required: true, message: this.$t('message.inputCustomerName')},
        ],
        customerCert: [
          {required: true, message: this.$t('message.inputCustomerCert')},
        ],
        customerEmail: [
          {required: true, message: this.$t('message.inputCustomerEmail')},
        ],
        customerPhone: [
          {required: true, message: this.$t('message.inputCustomerPhone')},
        ],
        defaultChannelName: [
          {required: true, message: this.$t('message.selectDefaultChannelName'), trigger: 'change'},
        ],
      },
      loading: null,
      title: "",
      submitted: false,
      result: {
        success: false,
        message: "",
        link: ""
      }
    };
  },
  computed: {
    defaultChannelNameOptions() {
      if (this.$store.state.isPK) {
        return [
          "easypaisa",
          "jazzcash",
          "qrcode:easypaisa",
          "qrcode:jazzcash",
          "card",
          "bill",
        ];
      }
      if (this.$store.state.isBD) {
        return ["bKash", "Rocket", "Nagad"];
      }
      return [];
    },
  },
  methods: {
    handleDialogOpen() {
      this.openDialog();
    },
    handleDialogClose() {
      this.closeDialog();
    },
    handleCancelClick() {
      this.closeDialog();
    },
    handleConfirmClick() {
      this.submit();
    },
    handleCloseClick() {
      this.closeDialog();
    },
    handleCopyClick() {
      this.copyRepaymentClick();
    },
    lockDialog() {
      this.loading = this.$loading({
        lock: true,
        text: this.$t("text.loading"),
        spinner: "el-icon-loading",
        target: "#createTestCollectionOrderDialog .el-dialog"
      });
    },
    unlockDialog() {
      if (this.loading !== null) {
        this.loading.close();
      }
    },
    openDialog() {
      this.title = this.$t('text.testOrder');
      this.submitted = false;
      this.result = {
        success: false,
        message: "",
        link: ""
      };
    },
    closeDialog() {
      this.$refs.form.resetFields();
      this.$bus.$emit("refresh");
      this.$emit("update:isShowCreateTestCollectionOrderDialog", false);
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.lockDialog();
          const defaultChannelName = this.form.defaultChannelName || "";
          const payload = {
            ...this.form,
            // 选 qrcode:* 时走 easypaisaQr/jazzcashQr 池；仅靠 defaultChannelName 不够
            isQrCodeVersion: defaultChannelName.startsWith("qrcode:"),
          };
          this.$axios
              .post("/order/createTestCollectionOrder", payload)
              .then((res) => {
                this.unlockDialog();
                if (res.code === 200) {
                  this.submitted = true;
                  this.processPayResult(res.data);
                  return true;
                } else {
                  this.$notify.error({
                    title: this.$t("text.prompt"),
                    message: res.msg
                  });
                  return false;
                }
              })
              .catch(() => {
                this.unlockDialog();
                this.$notify.error({
                  title: this.$t("text.prompt"),
                  message: this.$t("message.sysError")
                });
              });
        } else {
          return false;
        }
      });
    },
    processPayResult(payResult) {
      if (payResult.code !== 200 || payResult.status === "02") {
        this.result.success = false;
        this.result.message = payResult.msg;
        if (payResult.orderId === undefined) {
          this.title = `${this.$t('text.error')}`;
        } else {
          this.title = `${this.$t('text.error')} - ${payResult.orderId}`;
        }
      } else {
        this.result.success = true;
        this.result.link = payResult.payUrl;
        this.title = `${this.$t('text.success')} - ${payResult.orderId}`;
      }
    },
    copyRepaymentClick() {
      navigator.clipboard.writeText(this.result.link)
          .then(() => {
            this.$message.success(this.$t('message.copySuccess'));
          })
          .catch(() => {
            this.$message.error(this.$t('message.copyError'));
          });
    }
  },
  mounted() {
    this.openDialog();
  }
};
</script>
